import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1dde86ed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo knobs={{
      Button: ['kind', 'disabled', 'size']
    }} mdxType="ComponentDemo">{`<Button>Hello World!</Button>`}</ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      